export const imageBreakpoints: Record<number, number | number[]> = {
	1920: 200,
	1680: 200,
	1600: 200,
	1536: 200,
	1440: 200,
	1366: 200,
	1280: 200,
	428: [200, 300, 400],
	414: [200, 300, 400],
	412: [200, 300, 400],
	393: [200, 300, 400],
	390: [200, 300, 400],
	385: [200, 300, 400],
	384: [200, 300, 400],
	375: [200, 300, 400],
	360: [200, 300, 400],
	320: [200, 300, 400],
};
